<template>
  <div class="pt-4 px-3">
    <div id="config" class="flex flex-col border p-3 md:p-4 rounded-lg bg-white">

      <!-- الصف الأول: البحث + زر المزيد -->
      <div
        v-if="(!['userHistories','pointages','balances'].includes(name) && name !== 'affiliates') || (name === 'affiliates' && currentUser.type !== 'Seller')"
        class="flex flex-col md:flex-row md:items-stretch md:space-x-2 space-y-2 md:space-y-0"
      >
        <!-- حقل البحث + زر -->
        <div class="flex w-full">
          <input
            :placeholder="$t(config.filters.elements.search.options.hint)"
            v-model="searchText"
            @keyup.enter="trigger"
            type="search"
            autofill="off"
            class="border text-gray-700 text-sm md:text-xs rounded-l-md w-full focus:outline-none py-2 px-3 md:py-1 md:px-4"
          />
          <button
            @click="search"
            ref="sendReply"
            class="bg-white rounded-r-md text-green-600 border hover:opacity-75 px-3 focus:outline-none"
          >
            <i class="py-1 material-icons">search</i>
          </button>
        </div>

        <!-- زر إظهار المزيد -->
        <div class="self-center md:self-auto mt-2 md:mt-0">
          <button
            @click="showMore = !showMore"
            class="text-white rounded-full bg-green-600 flex items-center justify-center focus:outline-none p-2 ml-0 md:ml-2"
          >
            <i v-if="showMore" class="material-icons">keyboard_arrow_up</i>
            <i v-else class="material-icons">keyboard_arrow_down</i>
          </button>
        </div>
      </div>

      <!-- مجموعة الفلاتر -->
      <div class="flex flex-col mt-3" v-if="['sourcings','userHistories','affiliates'].includes(name) ? !showMore : showMore">

        <!-- شبكة الحقول -->
        <div class="flex flex-wrap -mx-2 justify-center">
          <div
            v-for="(item, index) in config.filters.elements.champs"
            :key="index"
            v-show="
            getShow(item.key) &&
              item.key!='from' &&
              item.key!='to' &&
               (isShown(item) && item.key!='date_remind') || 
               ((isShown(item) && item.key=='date_remind' && filter['status'] && filter['status_pending'] && filter['status_pending'].name == 'pending_remind')) ||
               (isShown(item) && filter['status_received'])"
            class="px-2 w-full sm:w-1/2 md:w-56"
          >
            <div  class="mb-3 mt-4">
              <div class="border hover:border-green-500 focus-within:border-blue-500 transition-all duration-300 rounded relative p-1">
                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-2xs md:text-xs">
                  <p>
                    <label class="bg-white text-gray-700 px-1">
                      {{$t(item.label)}} <span :class="$colors.required">*</span>
                    </label>
                  </p>
                </div>

                <!-- نوع select -->
                <div v-if="item.type=='select' && getShow(item.key)" class="relative">
                  <template v-if="item.name">
                    <span v-if="item.key=='product'">
                      <v-select
                        :label="item.name"
                        @search="getProducts($event)"
                        v-model="filter[item.key]"
                        :options="products"
                        class="w-full"
                      />
                    </span>
                    <span v-else>
                      <v-select
                        :class="[
                          config.name === 'orders' && item.key === 'status_pending' && (!checkstatusorder || checkstatusorder != 'Pending') ? 'opacity-75 pointer-events-none' : '',
                          config.name === 'orders' && item.key === 'status_pending_cancelled' && (!checkstatusorder || checkstatusorder != 'Cancelled') ? 'opacity-75 pointer-events-none' : '',
                        ]"
                        :multiple="item.multiple || false"
                        @input="CheckSellerProducts"
                        @search="getUsers($event,item.key)"
                        :label="item.name"
                        v-model="filter[item.key]"
                        :options="item.values"
                        class="w-full scrollable-tags"
                      />
                    </span>
                  </template>
                  <template v-else>
                    <v-select
                      v-if="['shippings'].includes(name) && item.key==='status'"
                      @input="setdataSelect"
                      v-model="filter[item.key]"
                      :options="item.values"
                      label="label"
                      :reduce="opt => opt.value"
                      class="w-full"
                    />
                    <v-select
                      v-else
                      @input="setdataSelect"
                      v-model="filter[item.key]"
                      :options="item.values"
                      class="w-full"
                    />
                  </template>
                </div>

                <!-- number -->
                <div v-else-if="item.type=='number'">
                  <input
                    :min="item.min"
                    :step="item.step"
                    v-model="filter[item.key]"
                    :type="item.type"
                    :name="item.key"
                    :id="item.key"
                    class="w-full h-10 px-3 text-sm border-0 focus:outline-none"
                  />
                </div>

                <!-- range_numbers -->
                <div v-else-if="item.type=='range_numbers'" class="py-1">
                  <MultiRangeSlider
                    :min="0"
                    :max="12"
                    baseClassName="multi-range-slider-bar-only"
                    :minValue="item.value.min"
                    :maxValue="item.value.max"
                    @input="UpdateValues"
                  />
                </div>

                <!-- نص/تاريخ -->
                <div v-else>
                  <input
                    v-if="item.type!='date_range'"
                    v-model="filter[item.key]"
                    :placeholder="item.placeholder"
                    :type="item.type"
                    :name="item.key"
                    :id="item.key"
                    class="w-full h-10 px-3 text-sm border-0 focus:outline-none"
                  />
                  <date-picker
                    v-else
                    :placeholder="item.placeholder"
                    @change="DateRange"
                    format="YYYY-MM-DD"
                    class="w-full-imp"
                    v-model="filter[item.key]"
                    range
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- من / إلى -->
        <div v-if="config.filters.hasFilterdate" class="flex flex-wrap -mx-2">
          <div
            v-for="(item, index) in config.filters.elements.champs"
            :key="index"
            v-show="isShown(item) && (item.key=='from' || item.key=='to')"
            class="px-2 w-full sm:w-1/2 md:w-56"
          >
            <div class="mb-3">
              <div class="border hover:border-blue-400 focus-within:border-blue-500 transition-all duration-300 rounded relative p-1">
                <div class="-mt-4 absolute tracking-wider px-1 capitalize text-2xs md:text-xs">
                  <p>
                    <label class="bg-white text-gray-700 px-1">
                      {{ item.label }} <span :class="$colors.required">*</span>
                    </label>
                  </p>
                </div>
                <input
                  v-model="filter[item.key]"
                  :type="item.type"
                  :name="item.key"
                  :id="item.key"
                  class="w-full h-10 px-3 text-sm border-0 focus:outline-none"
                />
              </div>
            </div>
          </div>
        </div>

        <!-- الأزرار -->
        <div class="flex flex-col sm:flex-row justify-center sm:space-x-2 mt-2 space-y-2 sm:space-y-0">
          <button
            @click="ClearFilters"
            class="text-green-600 rounded-md border border-gray-200 bg-gray-200 hover:bg-green-600 hover:text-white py-2 px-4 w-full sm:w-32 focus:outline-none loidingconfirm relative"
            :class="loading?'noselect':''"
          >
            {{$t('reset')}}
          </button>
          <button
            v-if="config.filters.elements.champs.length>0"
            @click="filtrer_saerch"
            class="rounded-md border border-gray-200 bg-green-600 hover:bg-green-600 text-white py-2 px-4 w-full sm:w-32 focus:outline-none loidingconfirm relative"
            :class="loading?'noselect':''"
          >
            {{$t('filtrer')}}
          </button>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    config: { type: Object},
    currentUser: { type: Object },
    idWharhouse: { type: Object },
    name:{type:String},
    loading:{required:false},
  },
  data() {
    return {
      showMore: false,
      searchText: "",
      warhouseCountry:"",
      filter: {},
      //idWharhouse:null,
      products:[],
      checkstatusorder:null,
      sellerSelected:null,
      barMinValue: 1,
      barMaxValue: 10,
    };
  },
  computed: {
      warhouseSelected(){
          return this.$store.getters["wharhouse/warhouseSelected"]({user:_.pick(this.currentUser,['countries'])})
          },
      },
  watch: {
      'warhouseSelected': async function(oldVal, newVal) {
          //  await this.getwharhouseId();
            
      },
      'idWharhouse': async function(oldVal, newVal) {
            this.idWharhouse=oldVal;  
            await this.getCurrentSellerProducts();
      },
      
  },

async  mounted() {
  //console.log('filter pr----- 1')
  this.warhouseCountry=await this.warhouseSelected;
   //await this.getwharhouseId();
    this.config.filters.elements.champs.forEach((filter) => {
      if (filter.value)
        this.$set(this.filter, filter.key, filter.value, filter.values);
    });    
    //console.log('filter pr----- 2')
    await this.getCurrentSellerProducts();
  },
  methods: {
    UpdateValues(e) {
      this.barMinValue = e.minValue;
      this.barMaxValue = e.maxValue;
      if(!this.filter.range_numbers) this.filter.range_numbers={};
     // console.log('filter 11----',this.filter)
      this.filter.range_numbers.min=e.minValue;
      this.filter.range_numbers.max=e.maxValue;
    //  console.log('UpdateValues filter----',this.filter)
    },
    DateRange(data){
    //console.log('data date-------------------', data.map( el => this.$moment(el).format('yyyy-MM-DD')))
   // console.log('data date-------------------', data)
    //console.log('data date 00-------------------',this.$moment(data[0]).format('yyyy-MM-DD'))
   // console.log('Range_updatedAt------',this.filter['Range_updatedAt'])
   // console.log('Range_date------',this.filter['Range_date'])
   
  },
     getShow(champ){
       if((champ==="seller" || champ==="courier" || champ==="zone") && this.currentUser.type ==="Seller") return false
       if((champ==="seller" && this.currentUser.type ==="Seller")) return  false
       if((champ==="status" && (this.currentUser.type ==="CancelledOrder" || this.currentUser.type=='ToRemind'))) return  false 
       if((champ==="status_pending" && (this.currentUser.type ==="CancelledOrder" || this.currentUser.type=='ToRemind'))) return  false 
       else return  true
     },
    trigger() {
      this.$refs.sendReply.click();
    },
    async getwharhouseId(){
          await this.$store.dispatch('wharhouse/getwharhouseId',{country:await this.warhouseSelected}).then((res) => {
                  this.idWharhouse=res;
              })
    },
   async getCurrentSellerProducts(){
      this.products = [];
     // console.log('filter pr----- 3',this.currentUser)
      //console.log('filter pr----- 4',this.idWharhouse)
      if (this.currentUser && this.currentUser.type == "Seller") {
              const filters = {
                seller: this.currentUser._id,
                'details.warehouse':this.idWharhouse._id,
                limit:10
              };
           //   console.log('filter pr-----',filters)
          const res = await this.$server.search("products",filters);
        //  console.log('filter pr-----',res.content)
          if (res.content.results) {
            this.products = res.content.results;
          } else this.products = [];
        }
    },
      async CheckSellerProducts(seller){
        console.log("status------",seller)
      if(this.name == "orders" && seller && seller.original && seller.original.color){
         this.checkstatusorder= seller.original.name ;
      }
      if((this.name=="shippings" || this.name=="orders") && seller && (seller.email || (Array.isArray(seller) && seller.length >0 && seller[0].email))){
          this.products = [];
          this.sellerSelected= Array.isArray(seller) ? seller.map( el => el._id) : [seller._id];
          const filters = {
            seller: { $in : this.sellerSelected },
            'details.warehouse':this.idWharhouse._id,
             limit:10
          };
          
          const res = await this.$server.search("products", filters);
          
          if (res.content.results) {
            this.products = res.content.results;
          } else {this.products = [];this.sellerSelected=null}
      }
    },
    getUsers: _.debounce(async function(name,type) {
    //  console.log('event______________',name)
       console.log('warhouset______________',type)
        if(['seller','courier','zone','teleConsultant'].includes(type)){
          await this.$store.dispatch('wharhouse/searchUser',{type: type,warhouse:this.idWharhouse.country,search:name}).then((res) => {
            console.log('res-----------',res)
            const objIndex = this.config.filters.elements.champs.findIndex((obj => obj.key == type));
            this.config.filters.elements.champs[objIndex].values = res
          })
        }
   }, 500), 
   getProducts: _.debounce(async function(name) {
     console.log('event______________',name)
     const filterParams=this.$f.QueryStringToobject();
      console.log('filterParams______________',filterParams)
     const filter={seller: { $in : this.sellerSelected },warhouse:this.idWharhouse._id,search:name,notPopulate:true};
     if(filterParams.seller) filter.seller=filterParams.seller;
        await this.$store.dispatch('wharhouse/searchProducts',filter).then((res) => {
            this.products = res;
        })
   }, 500), 
     reset: function (val) {
          this.$emit('reset',val);
      },
      filtrer: function (val) {
          this.$emit('filtrer',val);
      },
      search: function () {
        if(!this.loading) this.$emit('search',this.searchText);
      },
      searchUsers:async function (value,event) {
        console.log('type user',event)
         if(event=="seller" || event=="user") {
           this.$emit('searchSellers',value,event);
         }
         if(event=="courier") this.$emit('searchCouriers',value,event);
      },
      isShown(item) {
      // if(this.config.name === 'expeditions'){
       //  console.log('item exp---',item)
         //console.log('item exp filter---',this.filter['status_received'])
      // }
      let shown = !item.show || (item.show && this.filter[item.show.key] == item.show.equal);
      if(this.config.name === 'orders' && item.key === 'status_pending' && (!this.checkstatusorder || !['pending','en attente'].includes(this.checkstatusorder.toLowerCase()))) return false
      if(this.config.name === 'orders' && item.key === 'status_pending_cancelled' && (!this.checkstatusorder || !['cancelled','rejetée'].includes(this.checkstatusorder.toLowerCase()))) return false
      if(this.config.name === 'expeditions' && item.key === 'status_received' &&  (!this.checkstatusorder || this.checkstatusorder !== 'received')) return false
      if (!shown) this.$set(this.filter, item.key, null);
      return shown;
    },
    setdataSelect(value){
      this.checkstatusorder=value;
    },
    searc() {
      //console.log(this.articleType);
    },

    /*********************************************************************************** */
     async filtrer_saerch() {
      this.filtrer(this.filter);
    },
    async ClearFilters() {
      this.reset(this.filter);
      this.filter = {};
    },
  },
};
</script>

<style scoped>
.text-2xs { font-size: .7rem; line-height: 1rem; }

.v-select, .v-select .vs__dropdown-toggle { width: 100%; }

.v-select .vs__dropdown-menu { z-index: 40; }

.w-full-imp { width: 100% !important; }

#config label { cursor: default; }
</style>